import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import calendarServices from '../calendarServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';
import moment from 'moment';


function CalenderEventForm({data,callBack,callBackWithId }) {

    const {AppAlert} = useAlert();
    const {masters} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {
        sequence:0,
        title:"",
        details:"",
        startDate:moment().format(moment.HTML5_FMT.DATE),
        startTime:moment().add(1,"hours").startOf('hour').format(moment.HTML5_FMT.TIME),
        endDate:moment().format(moment.HTML5_FMT.DATE),
        endTime:moment().add(2,"hours").startOf('hour').format(moment.HTML5_FMT.TIME),
        calendarType:"1",
        priority:"1",
        to:"",
        status:"",
        notify:0,
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            sequence:Number(data.sequence+1),
            title:data.title,
            details:data.details,
            startDate:data.startDate,
            startTime:data.startTime,
            endDate:data.endDate,
            endTime:data.endTime,
            calendarType:data.calendarType,
            priority:data.priority,
            to:data.to,
            status:data.status,
            notify:0,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        title:Yup.string().required("Required"),
        startDate:Yup.string().required("Required"),
        startTime:Yup.string().required("Required"),
        to:Yup.string().email(),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        calendarServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            if(callBackWithId){
                callBackWithId(res.id);
            } else {
                callBack();
            }
            
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New Event</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Add New"}</DialogTitle>
                                    <DialogContent>
                                            <div className='row'>
                                                <div className='col-md-8'>
                                                    <div className="row ">
                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="input" formik={formik} type="text" 
                                                                label="Title" name="title" 
                                                            />
                                                        </div>

                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="input" formik={formik} type="text" multiline={true} rows={3}
                                                                label="Details" name="details" 
                                                            />
                                                        </div>

                                                        <div className="col-md-6 my-2" >
                                                            <FormikControl control="input" formik={formik} type="date" 
                                                                label="Start Date" name="startDate" 
                                                            />
                                                        </div>
                                                        <div className="col-md-6 my-2" >
                                                            <FormikControl control="input" formik={formik} type="time" 
                                                                label="Start Time" name="startTime" 
                                                            />
                                                        </div>

                                                        <div className="col-md-6 my-2" >
                                                            <FormikControl control="input" formik={formik} type="date" 
                                                                label="End Date" name="endDate" 
                                                            />
                                                        </div>
                                                        <div className="col-md-6 my-2" >
                                                            <FormikControl control="input" formik={formik} type="time" 
                                                                label="End Time" name="endTime" 
                                                            />
                                                        </div>

                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="input" formik={formik} type="text"
                                                                label="Notify To" name="to"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='row'>
                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="autoselect" formik={formik}
                                                                options={masters['task-status']}
                                                                label="Task Status" name="status"
                                                            />
                                                        </div>

                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="radio" formik={formik}
                                                                options={
                                                                    [
                                                                        {label:"Meeting",value:1},
                                                                        {label:"Task",value:2},
                                                                        {label:"Reminder",value:3}
                                                                    ]
                                                                }
                                                                label="Type" name="calendarType"
                                                            />
                                                        </div>

                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="radio" formik={formik}
                                                                options={
                                                                    [
                                                                        {label:"High",value:1},
                                                                        {label:"Med",value:2},
                                                                        {label:"Low",value:3}
                                                                    ]
                                                                }
                                                                label="Priority" name="priority"
                                                            />
                                                        </div>

                                                        <div className="col-md-12 my-2" >
                                                            <FormikControl control="switch" formik={formik}
                                                                
                                                                label="Notify" name="notify"
                                                            />
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values) */ }
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default CalenderEventForm